import { recreateFindingsArray } from './FindingsWidgets';
import { extractInfrastructureFindings } from './KeyFindingsAdvancedWidgetHelper';
import { extractManagedServiceFindings } from './ManagedServiceExperienceWidgetHelper';
import { extractSecurityFindings } from './SecurityScanGridWidgetHelper';
import { extractCyberSecurityFindings } from './CyberSecurityGridWidgetHelper';

/**
 * Robustly extract findings from ALL possible scan types and merge them.
 * This is the ultimate "one-stop-shop" for finding data in the report.
 */
export const calculateAllReportFindings = (data, scanGroups = [], availableCategories = []) => {
    if (!data) return [];

    // 1. Get standard findings (Network, AD, MS365, Localhost, PII, Dark Web)
    const standardFindings = recreateFindingsArray(data);
    
    // 2. Get Infrastructure findings
    const infraFindings = extractInfrastructureFindings(data).map(f => [
        f.title, 
        f.status, 
        f.score, 
        f.description, 
        0, 
        { count: f.value, total: 100 }, 
        'Infrastructure'
    ]);

    // 3. Get Managed IT findings
    const managedFindings = extractManagedServiceFindings(data).map(f => [
        f.title, 
        f.status, 
        f.score, 
        f.description, 
        0, 
        { count: f.value, total: 100 }, 
        'Managed IT/Service Experience'
    ]);

    // 4. Get Security findings
    const securityFindings = extractSecurityFindings(data).map(f => [
        f.title, 
        f.status, 
        f.score, 
        f.description, 
        0, 
        { count: f.value, total: 100 }, 
        'Security'
    ]);

    // 5. Get Cyber Security findings
    const cyberFindings = extractCyberSecurityFindings(data).map(f => [
        f.title, 
        f.status, 
        f.score, 
        f.description, 
        0, 
        { count: f.value, total: 100 }, 
        'Cyber Security (Threat & Exposure)'
    ]);

    // Merge everything
    const allFindings = [
        ...standardFindings,
        ...infraFindings,
        ...managedFindings,
        ...securityFindings,
        ...cyberFindings
    ];

    // De-duplicate by name, keeping the one with the best status if multiple exist
    const merged = new Map();
    const severityOrder = { 'Critical': 4, 'Red': 4, 'Bad': 4, 'Warning': 3, 'Yellow': 3, 'Moderate': 3, 'Healthy': 2, 'Green': 2, 'Good': 2, 'Unknown': 1, 'N/A': 0 };

    allFindings.forEach(f => {
        const name = f[0];
        if (!merged.has(name)) {
            merged.set(name, f);
        } else {
            const existing = merged.get(name);
            const currentSeverity = severityOrder[f[1]] || 0;
            const existingSeverity = severityOrder[existing[1]] || 0;
            if (currentSeverity > existingSeverity) {
                merged.set(name, f);
            }
        }
    });

    return Array.from(merged.values());
};
